import * as React from "react";
import { DynamicDeliveryIndicator } from "@grandvisionhq/shipping";
const DynamicDeliveryIndicatorContainer = (props) => {
  if (props.isExcludedFromCheckout) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(DynamicDeliveryIndicator, { ...props, view: "text" });
};
export {
  DynamicDeliveryIndicatorContainer as D
};
//# sourceMappingURL=DynamicDeliveryIndicatorContainer.js.map
